import { GET_REGISTRATIONS_EXAM_LEVELS_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_REGISTRATIONS_EXAM_LEVELS_QUERY_KEY } from '../../constants/queryKeys';
import { KeyValueResponse } from '../../api';

interface Input {
  nationalType: string;
  accountType: string;
  onSuccess?: (res: ExamLevelResponse[]) => void;
}

export interface ExamLevelResponse extends KeyValueResponse {
  uuid: string;
}

export const useGetExamRegistrationLevels = ({ nationalType, accountType, onSuccess }: Input) => {
  const getExamRegistrationLevels = async () => {
    const res = await axiosClient.get<ExamLevelResponse[]>(
      GET_REGISTRATIONS_EXAM_LEVELS_URL(nationalType, accountType)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_REGISTRATIONS_EXAM_LEVELS_QUERY_KEY, nationalType, accountType],
    getExamRegistrationLevels,
    {
      enabled: !!accountType,
      onSuccess,
    }
  );
};
